(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.password-reset-complete-confirmation', ['pp.widgets-templates', 'pp.services.core']);

ngModule.component('ppPasswordResetCompleteConfirmation', {
    templateUrl: 'widgets/_angular/password-reset-complete-confirmation/password-reset-complete-confirmation.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', 'ppTrack', 'authenticateInvestor', function ($scope, ppTrack, authenticateInvestor) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        vm.onClickLogin = function () {
            ppTrack.action('reset-complete.login.click');
            authenticateInvestor();
        };

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);